import { Metamodel } from 'app/model/base/model';
import { DataFlowStream } from 'app/model/dataflow/transformation';

import { BaseColumnMappingTransformation } from './base-column-mapping-transformation';

@Metamodel.model({
    name: 'output',
    display: [stringResources.DataFlowOutputTransformationLabel, stringResources.DataFlowOutputTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    }
})
export class OutputTransformation extends BaseColumnMappingTransformation {
    public get outputStream(): DataFlowStream {
        if (this.outputStreams.size > 1) {
            throw new Error(`${Metamodel.modelOf(this).name}/${this.name} transformation suppose to have only single output stream not multiple.`);
        }
        return this.outputStreams.values().next().value;
    }

    protected getGeneratedDescription(): string {
        return stringResources.OutputTransformationDescription;
    }
}
